/**
 * Accounting's deposit-slip modal is the last reader of the deprecated `memberships(take)` root (P7-R53);
 * order pickers read `MembershipOptionsQuery` (modules/entities/memberships).
 */
export const GET_MEMBERSHIPS = gql`
  query OrganizationMembershipsQuery {
    memberships(take: 5000) {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

/** Written by `settings/team/hooks/useUpdateMembership`. */
export const UPDATE_MEMBER = gql`
  mutation UpdateMembership($id: Int!, $input: UpdateMembershipInput!) {
    updateMembership(id: $id, input: $input) {
      id
    }
  }
`;
